import { keycodeFromEvent } from 'shared/helpers';

import { toggleMarkWorkaround } from '../utils';

// TODO: Maybe at some point try to switch to is-hotkey,
// but it seems to be calling way too many funcs at every key stroke..?


// snake_case just because easier to read.
const hotkeyMatcher = {
  cmd_b(e) {
    const { code, kc } = keycodeFromEvent(e);

    return (
      e.metaKey
      && !e.shiftKey
      && !e.altKey
      && code === kc.codes.b
    ) ? true : false;
  },

  cmd_i(e) {
    const { code, kc } = keycodeFromEvent(e);

    return (
      e.metaKey
      && !e.shiftKey
      && !e.altKey
      && code === kc.codes.i
    ) ? true : false;
  },

  cmd_z(e) {
    const { code, kc } = keycodeFromEvent(e);

    return (
      e.metaKey
      && !e.shiftKey
      && !e.altKey
      && code === kc.codes.z
    ) ? true : false;
  },

  cmd_opt_s(e) {
    const { code, kc } = keycodeFromEvent(e);

    return (
      e.metaKey
      && e.altKey
      && !e.shiftKey
      && code === kc.codes.s
    ) ? true : false;
  },
}


const SetHotkey_ToggleMark = (opts = {}) => ({
  onKeyDown(e, change, editor) {
    const {
      matcher = () => false,
      mark,
    } = opts

    const isMatched = matcher(e);
    if (!isMatched) return;

    e.preventDefault();
    return toggleMarkWorkaround(change, mark);
  }
});


export {
  hotkeyMatcher,
  SetHotkey_ToggleMark,
}



// WEBPACK FOOTER //
// ./src/components/slate/plugins/SetHotkey.js